import inView from 'in-view';
import { CountUp } from 'countup.js/dist/countUp.umd';

inView('.js-counter')
	.on('enter', (el) => {
		const { number } = el.dataset;
		console.log(number);
		if (number) {
			let decimalPlaces = 0;
			const decimalIndex = number.indexOf('.');
			if (decimalIndex > 0) {
				decimalPlaces = number.length - decimalIndex - 1;
			}

			const options = {
				decimalPlaces,
			};

			const countUp = new CountUp(el, number, options);
			countUp.start();
		}
	});
